import React, { useMemo } from 'react';
import {
  getFormatedExpirationDate,
  getFormatedNumber,
  getMaskedDisplayNumber,
  getCardBrand,
} from 'cvlib/components/InputCard/utils/format';
import { Card } from '../Card';

export const CardPreview = ({
  number = '',
  expirationDate = '',
}) => {
  const cardType = useMemo(() => getCardBrand(number).cardType, [number]);
  const formatedNumber = useMemo(() => getFormatedNumber(number, ''), [
    number,
  ]);
  const formatedEDate = useMemo(
    () => getFormatedExpirationDate(expirationDate),
    [expirationDate],
  );

  return (
    <Card
      number={getMaskedDisplayNumber(formatedNumber)}
      brand={cardType}
      expire={formatedEDate}
    />
  );
};

export default CardPreview;
